// src/components/home/VehicleCard.jsx

import React from "react";
import {
  Users,
  ArrowRight,
  Maximize2,
} from "lucide-react";

const VehicleCard = ({
  vehicle,
  image,
  onBook,
  onImageClick,
}) => {
  return (
    <article
      className="
        group
        w-full
        overflow-hidden
        rounded-2xl
        border
        border-[#E2E8E5]
        bg-white
        shadow-sm
        transition-all
        duration-300
        hover:-translate-y-1
        hover:shadow-lg
      "
    >
      {/* =====================================================
          VEHICLE IMAGE
      ===================================================== */}

      <button
        type="button"
        onClick={onImageClick}
        aria-label={`View ${vehicle?.name || "vehicle"} image`}
        className="
          relative
          block
          h-[150px]
          w-full
          overflow-hidden
          bg-[#F1F5F3]
          text-left
          focus:outline-none
          focus-visible:ring-2
          focus-visible:ring-[#00A260]
          focus-visible:ring-inset

          sm:h-[165px]

          lg:h-[175px]
        "
      >
        {image ? (
          <img
            src={image}
            alt={vehicle?.name || "Vehicle"}
            loading="lazy"
            className="
              h-full
              w-full
              object-cover
              transition-transform
              duration-700
              ease-out
              group-hover:scale-[1.04]
            "
          />
        ) : (
          <div
            className="
              flex
              h-full
              w-full
              items-center
              justify-center
              text-[#94A3B8]
            "
          >
            <div className="text-center">
              <div
                className="
                  mx-auto
                  flex
                  h-10
                  w-10
                  items-center
                  justify-center
                  rounded-xl
                  bg-white
                  text-[#94A3B8]
                "
              >
                <Maximize2 className="h-4 w-4" />
              </div>

              <span className="mt-2 block text-xs font-medium">
                Vehicle image unavailable
              </span>
            </div>
          </div>
        )}

        {/* Image overlay */}

        <div
          className="
            pointer-events-none
            absolute
            inset-0
            bg-gradient-to-t
            from-black/55
            via-black/5
            to-transparent
            opacity-0
            transition-opacity
            duration-300
            group-hover:opacity-100
          "
        />

        {/* View button */}

        <div
          className="
            absolute
            bottom-3
            right-3
            flex
            h-9
            w-9
            items-center
            justify-center
            rounded-full
            bg-white/95
            text-[#061A3A]
            opacity-0
            shadow-lg
            backdrop-blur-sm
            transition-all
            duration-300
            group-hover:opacity-100
          "
        >
          <Maximize2 className="h-4 w-4" />
        </div>

        {/* View photo */}

        <div
          className="
            absolute
            bottom-3
            left-3
            rounded-full
            bg-black/55
            px-2.5
            py-1
            text-[10px]
            font-semibold
            text-white
            opacity-0
            backdrop-blur-sm
            transition-opacity
            duration-300
            group-hover:opacity-100
          "
        >
          View photo
        </div>
      </button>

      {/* =====================================================
          VEHICLE DETAILS
      ===================================================== */}

      <div className="p-4">
        {/* Vehicle name */}

        <h3
          className="
            line-clamp-1
            text-[15px]
            font-bold
            leading-5
            text-[#061A3A]
            sm:text-base
          "
        >
          {vehicle?.name || "Vehicle"}
        </h3>

        {/* Description */}

        {vehicle?.description && (
          <p
            className="
              mt-1.5
              line-clamp-2
              text-xs
              leading-[18px]
              text-[#64748B]
            "
          >
            {vehicle.description}
          </p>
        )}

        {/* =================================================
            VEHICLE INFO
        ================================================= */}

        <div className="mt-3 flex items-center justify-between gap-2">
          {/* Seats */}

          {/* {vehicle?.passengers && (
            <div
              className="
                inline-flex
                items-center
                gap-1.5
                rounded-lg
                bg-[#00A260]/5
                px-2.5
                py-1.5
                text-[11px]
                font-semibold
                text-[#061A3A]
              "
            >
              <Users className="h-3.5 w-3.5 text-[#00A260]" />

              <span>
                {vehicle.passengers} Seats
              </span>
            </div>
          )} */}

          {/* Luggage */}

          {/* {vehicle?.luggage && (
            <span
              className="
                whitespace-nowrap
                text-[10px]
                font-medium
                text-[#94A3B8]
              "
            >
              {vehicle.luggage} luggage
            </span>
          )} */}
        </div>

        {/* =================================================
            PRICE
        ================================================= */}

        {vehicle?.price_from && (
          <p className="mt-2 text-[11px] text-[#64748B]">
            From{" "}
            <span className="font-bold text-[#061A3A]">
              ₹{vehicle.price_from}
            </span>
          </p>
        )}

        {/* =================================================
            STATUS
        ================================================= */}

        {vehicle?.status && (
          <div className="mt-2 flex items-center gap-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-[#00A260]" />

            <span className="text-[10px] font-semibold text-[#00A260]">
              {vehicle.status}
            </span>
          </div>
        )}

        {/* =================================================
            BOOK BUTTON
        ================================================= */}

        {/* <button
          type="button"
          onClick={() => onBook?.(vehicle)}
          className="
            mt-3
            inline-flex
            h-10
            w-full
            items-center
            justify-center
            gap-1.5
            rounded-xl
            bg-[#00A260]
            px-3
            text-xs
            font-bold
            text-white
            transition-all
            duration-300
            hover:bg-[#005543]
            hover:shadow-md
            active:scale-[0.98]
            sm:text-sm
          "
        >
          Book Now

          <ArrowRight className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
        </button> */}
      </div>
    </article>
  );
};

export default VehicleCard;